require ("../bootstrap-sass/assets/javascripts/bootstrap/transition");
require ("../bootstrap-sass/assets/javascripts/bootstrap/alert");
require ("../bootstrap-sass/assets/javascripts/bootstrap/collapse");
require ("../bootstrap-sass/assets/javascripts/bootstrap/dropdown");
require ("../bootstrap-sass/assets/javascripts/bootstrap/modal");
require ("../bootstrap-sass/assets/javascripts/bootstrap/tooltip");
